export default __webpack_public_path__ + "static/media/gemini_gray.e03a42d9.png";